import { Flex } from 'antd';
import ErrorMessage from '../error-message/ErrorMessage';
import styles from './FloatingInput.module.scss';
import { LuEye, LuEyeOff } from 'react-icons/lu';
import { useState } from 'react';
import cx from 'clsx';
import { IF } from 'common';
import CopyToClipboard from 'common/copy-to-clipboard/CopyToClipboard';
import { getAutoComplete } from '../../utils/autofill-util';

const FloatingInput = ({
  handleChange,
  value,
  label,
  error,
  name,
  type: inputType,
  onBlur = () => { },
  small_height = false,
  extra_small_height = false,
  outerClassName = '',
  showCopyAction = false,
  autoComplete,
  ...props
}) => {
  const [type, setType] = useState(inputType);
  const extraAction = inputType === 'password' || showCopyAction;
  const resolvedAutoComplete = autoComplete ?? getAutoComplete({ type: inputType });

  return (
    <Flex vertical gap={3} className={cx('w-full', outerClassName)}>
      <div
        className={`${styles['float-input']} ${small_height && styles.small_height} ${extra_small_height && styles.extra_small_height} ${!!error && styles.error} ${extraAction && styles.extraAction} ${type === 'password' && styles.displayPassword}`}
      >
        <input
          onChange={handleChange}
          value={value ?? ''}
          placeholder=" "
          name={name}
          onBlur={onBlur}
          type={type || 'text'}
          id={name}
          autoComplete={resolvedAutoComplete}
          {...props}
        />
        <IF condition={inputType === 'password'}>
          <div onClick={() => setType(type === 'text' ? 'password' : 'text')} className={styles.extraActionIcon}>
            {type === 'password' ? <LuEyeOff size={20} /> : <LuEye size={22} />}
          </div>
        </IF>

        <IF condition={showCopyAction && value}>
          <div className={styles.extraActionIcon}>
            <CopyToClipboard value={value} hideText isAnimate={false} />
          </div>
        </IF>

        <label htmlFor={name}>{label}</label>
      </div>
      {error && <ErrorMessage errorMessage={error} />}
    </Flex>
  );
};

export default FloatingInput;
